<template>
  <div class="table-responsive">
    <table class="table align-items-center mb-0 table-hover " ref="tableDataGs">
    <thead>
      <tr>
        <th v-if="number_rows" class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2 w-30px" >№</th>
        <th
          v-for="(col, i) in columns"
          :key="col?.prop || col?.label || i"
          class="p-1"
          :aria-sort="getAriaSort(col)"
        >
          <label
              class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 d-flex justify-content-center align-items-center cursor-pointer"
              :class="col?.th_class"
              :style="col?.th_style"
              @click="onHeaderClick(col, $event)"
          >
            <input v-if="col?.th_radio" type="radio" :value="col.th_radio.value" v-model="data.th_radio[col.th_radio.name]" class="d-none label_tabel_like_input" />
            <el-tooltip v-if="col?.title && col?.label" :content="!col?.i18 ? $t(col?.title) : col?.title">
            <span class="like-label" :class="getClassForTypeData(col?.style_type_data)">
              {{!col?.i18 ? $t(col?.label ?? col.prop) : col?.label ?? col.prop}}
              <i class="far fa-question-circle"></i>
            </span>



            </el-tooltip>
            <span v-else-if="col?.label" class="like-label" :class="getClassForTypeData(col?.style_type_data)">
              {{!col?.i18 ? $t(col?.label ?? col.prop) : col?.label ?? col.prop}}
            </span>

            <span
                v-if="enableSorting && isColumnSortable(col) "
                :key="'sort-wrapper-' + i + '-' + (currentSort.prop === col.prop ? currentSort.direction : 'default')"
            >
              <i
                  v-if="currentSort.prop !== col.prop || currentSort.prop === null"
                  class="ms-1 text-secondary fas fa-sort"
              ></i>
            <i
                v-else-if="currentSort.direction === 'asc'"
                class="ms-1 text-secondary fas fa-sort-up"
            ></i>
            <i
                v-else-if="currentSort.direction === 'desc'"
                class="ms-1 text-secondary fas fa-sort-down"
            ></i>
            </span>

          </label>

        </th>
      </tr>
      <tr v-if="showFilters">
        <td v-if="number_rows"></td>
        <td
            v-for="(col, i) in columns"
            :key="'filter-' + (col?.prop || col?.label || i)"
            class="py-1 text-center"
        >

<!--          <el-select-->
<!--              v-if="col?.filter?.type === 'select' "-->
<!--              @change="console.log($event); $emit('filter', {prop: col.filter.prop ?? col.prop, val: $event.target.value })"-->
<!--              :value-on-clear="null"-->
<!--              :empty-values="[null]"-->
<!--              clearable-->
<!--          >-->
<!--            <el-option-->
<!--                v-for="option in col.filter.options"-->
<!--                :key="option.value"-->
<!--                :label="option.text"-->
<!--                :value="option.value"-->
<!--                :disabled="option?.disabled"-->
<!--            />-->
<!--          </el-select>-->


          <select
              v-if="col?.filter?.type === 'select' "
              class="form-select form-select-sm"
              @change="$emit('filter', {prop: col.filter.prop ?? col.prop, val: $event.target.value })"
              style="min-width: 40px"
          >
            <option v-for="option in col.filter.options" :key="option.value" :value="option.value" :disabled="option?.disabled">
              {{ option.text }}
            </option>
          </select>

          <UtmField
              v-if="col?.filter?.type === 'utm' "
              @change="$emit('filter', {prop: col.filter?.prop ?? col.prop, val: $event })"
              :returnSimpleObj="true"
              useKey = "name"
              :resourceKeys="col.filter?.resourceKeys ?? null"
          ></UtmField>

          <input
              v-if="col?.filter?.type === 'number' || col?.filter?.type === 'text' "
              :type="col.filter.type ?? 'text'"
               class="form-control form-control-sm"
               value=""
               @change="$emit('filter', {prop: col.filter?.prop ?? col.prop, val: $event.target.value })"
              :max="col.filter.max ?? '250'"
              :min="col.filter.min ?? '2'"
              :placeholder = "col.filter.placeholder ?? ''"
              style="min-width: 40px"
          />

          <TableDateFilter
              v-if="col?.filter?.type === 'date'"
              @change="$emit('filter', {prop: col.filter?.prop ?? col.prop, val: $event })"
          />


        </td>
      </tr>
    </thead>
    <tbody>
      <tr v-if="loading">
        <td :colspan="columns.length + (number_rows ? 1 : 0)" class="py-5 ">
          <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </td>
      </tr>
      <tr
        v-if="!loading && (!tableData || !tableData.length)"
      >
        <td :colspan="columns.length + (number_rows ? 1 : 0)" class="text-center text-dark py-5" style="text-align: center !important;">
          {{$t('General.NoData')}}
        </td>
      </tr>

      <template v-if="!loading && tableData && tableData.length">
        <custom_tr
            v-for="(tr, i) in tableData"
            :key="getRowKey(tr, i)"
            :tr = tr
            :i = i
            :columns = columns
            :number_rows = number_rows
        ></custom_tr>
      </template>

<!--      <tr-->
<!--          v-for="(tr, i) in tableData"-->
<!--          :key = i-->
<!--      >-->
<!--        <td v-if="number_rows" class="text-xxs">-->
<!--          {{i + number_rows}}-->
<!--        </td>-->
<!--        <td-->
<!--            v-for="(col, tdi) in columns"-->
<!--            :key = tdi-->
<!--            class="text-xs text-center"-->
<!--            :class="col?.td_class"-->
<!--            :style="col?.td_style"-->
<!--        >-->
<!--          <input v-if="col?.checkbox" type="checkbox" :value="getCheckboxValue(tr, col)" v-model="data.row_checkboxes[col?.checkbox.name]" />-->

<!--&lt;!&ndash;          <span  v-if = "col?.type === 'bool'">&ndash;&gt;-->
<!--&lt;!&ndash;            <span v-if = "tr[col.prop]" class="badge badge-sm bg-gradient-success">{{$t(col?.text_true)}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;            <span v-if = "!tr[col.prop]" class="badge badge-sm bg-gradient-danger">{{$t(col?.text_false)}}</span>&ndash;&gt;-->
<!--&lt;!&ndash;          </span>&ndash;&gt;-->
<!--&lt;!&ndash;          <div v-if="col?.buttons">&ndash;&gt;-->
<!--          <span-->
<!--              v-for="(button, n_b) in col?.buttons"-->
<!--              :key = "i + 'b' + n_b"-->
<!--          >-->
<!--            <button-->
<!--                v-if="button.if_callback === undefined || button.if_callback(tr)"-->
<!--                @click = button.click(tr)-->
<!--                v-html="button.label"-->
<!--                class="btn btn-sm p-2 py-1 m-0 mx-1"-->
<!--                :title="button?.title ?? null"-->
<!--                data-bs-toggle="tooltip"-->
<!--            ></button>-->
<!--          </span>-->

<!--&lt;!&ndash;          </div>&ndash;&gt;-->

<!--          <i v-if="col?.allow_tariff > this.store.state.init.user.tariff" class="fas fa-star" style="color: #5858e0;"></i>-->
<!--          <span v-else>-->
<!--            <span v-if="col?.foo" v-html="reduction(col, col.foo(tr[col.prop], tr))" :class="col?.item_class" @click="() => { if (col?.click) { col.click(tr) } else { return false } }"></span>-->

<!--            <span v-else :class="col?.item_class" @click="() => { if (col?.click) { col.click(tr) } else { return false } }">-->
<!--                {{reduction(col, tr[col.prop]) ?? col?.empty}} {{col?.unit ?? ''}}-->
<!--              <span v-if="col?.add_prop && tr[col.add_prop] && tr[col.prop] !== tr[col.add_prop]" class="badge bg-info ms-2">{{tr[col.add_prop]}}</span>-->
<!--            </span>-->
<!--          </span>-->

<!--        </td>-->
<!--      </tr>-->
    </tbody>
  </table>
  </div>
</template>

<script>
import store from "@/store/store";
import globalHelper from "@/helpers/globalHelper"
import custom_tr from "./_tr.vue"
import UtmField from "@/views/components/graspil/ConditionFields/UtmField.vue";
import TableDateFilter from "@/components/TableDateFilter.vue";

export default {
  computed: {
    store() {
      return store
    }
  },
  components: {UtmField, custom_tr, TableDateFilter },
  props: {
    tableData: {
      type: Array,
      default: null,
    },
    columns: {
      type: Array,
      default: null,
    },
    number_rows: {
      type: Number,
      default: 0,
    },
    showFilters: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    autoCheck: {
      type: Number,
      default: 0
    },
    enableSorting: {
      type: Boolean,
      default: false
    },
    initialSort: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      data:{
        row_checkboxes:{},
        th_radio: {},
        lines: []
      },
      checkboxes: {},
      currentSort: {
        prop: null,
        direction: null
      }
    }
  },
  watch: {
    // c: {
    //   handler: function (val, oldVal) { /* ... */ },
    //   deep: true
    // },
    data: {
      handler: function(val) {
        this.$emit('checkboxes', val)
      },
      deep: true
    }
  },
  methods: {
    ...globalHelper,
    getAriaSort(col) {
      if (!this.enableSorting || !this.isColumnSortable(col)) return 'none'
      if (this.currentSort.prop !== col.prop) return 'none'
      if (this.currentSort.direction === 'asc') return 'ascending'
      if (this.currentSort.direction === 'desc') return 'descending'
      return 'none'
    },
    getSortIconClass(col) {
      if (this.currentSort.prop !== col.prop) return 'fas fa-sort'
      if (this.currentSort.direction === 'asc') return 'fas fa-sort-up'
      if (this.currentSort.direction === 'desc') return 'fas fa-sort-down'
      return 'fas fa-sort'
    },
    getRowKey(tr, i) {
      // Prefer stable identifiers to avoid DOM patching issues when data changes
      return (
          tr?.id ??
          tr?.user_id ??
          tr?._id ??
          tr?.uuid ??
          tr?.key ??
          i
      )
    },
    isColumnSortable(col) {
      return !!(this.enableSorting && col && col.prop && col.sortable !== false)
    },
    onHeaderClick(col, event) {
      // respect tariff restriction for radio-like headers
      if (
          col?.th_radio &&
          (this.store.state.init.current_bot.tariff < col?.th_radio?.allow_tariff)
      ) {
        this.showNotify(this.$t('Notify.NotAllowOnTariff'), 'warning')
        event && event.preventDefault()
        return
      }

      if (!this.isColumnSortable(col)) {
        return
      }

      // toggle sort: none -> asc -> desc -> none (mutate in-place to keep reactive ref stable)
      if (this.currentSort.prop !== col.prop) {
        this.currentSort.prop = col.prop
        this.currentSort.direction = 'asc'
      } else if (this.currentSort.direction === 'asc') {
        this.currentSort.direction = 'desc'
      } else if (this.currentSort.direction === 'desc') {
        this.currentSort.prop = null
        this.currentSort.direction = null
      } else {
        this.currentSort.prop = col.prop
        this.currentSort.direction = 'asc'
      }

      const payload = {}
      if (this.currentSort.prop && this.currentSort.direction) {
        payload[this.currentSort.prop] = this.currentSort.direction
      }

      this.$emit('sort-change', payload)
    },
    reduction: function(col, val){
      if (col?.replaceSomeData && col?.replaceSomeData[val] !== undefined) {
        return col?.replaceSomeData[val]
      }
      if ((typeof val !== "number" && col?.type_data !== "number") || col?.reduction === false || val < 1000) {
        return val
      }
      val = val / 1000
      return val.toFixed(2) + 'k'
    },
    getClassForTypeData: function (type) {
      if (type === 'bot') {
        return 'type-data-bot '
      }
      if (type === 'app') {
        return 'type-data-app '
      }
      if (type === 'all') {
        return 'type-data-all '
      }

    },
    // дублируется функция в _tr
    getCheckboxValue: function(tr, col) {
      if (col?.checkbox?.type === 'int') {
        return parseInt( tr[col?.checkbox.prop])
      }

      if (Array.isArray(tr[col?.checkbox.prop])) {
        return  tr[col?.checkbox.prop].join(',')
      }
      return  tr[col?.checkbox.prop]
    }
  },
  mounted() {
    let data = {...this.data}
    for (let col of this.columns) {
      if (col?.th_radio && !this.data.th_radio[col.th_radio.name]) {
        data.th_radio[col.th_radio.name] = col.th_radio.checked ? col.th_radio.value : false
      }
    }

    if (this.autoCheck) {
      let autoCheck = this.autoCheck
      let checkboxes = [];
      for (let tr of this.tableData) {
        for (let col of this.columns) {
          if (!col?.checkbox) {
            continue
          }
          if (autoCheck === 0) {
            break;
          }
          // if (checkboxes[col?.checkbox.name] === undefined) {
          //   continue
          // }

          let nameLine = this.getCheckboxValue(tr, col)
          this.$store.dispatch('report/getColor', nameLine)
          this.$store.commit('report/addLinesAdditionalData', { name: nameLine, data: { ...tr } })

          checkboxes.push(nameLine)
          this.$store.commit('report/__set', { name: 'lines', val: checkboxes })
          autoCheck--;
        }
        if (autoCheck === 0) {
          break;
        }
      }
      // this.checkboxes = checkboxes
      // this.$emit('checkboxes', checkboxes)
      data.lines = checkboxes
    }
    this.data = data

    // initialize sorting state (mutate in-place)
    if (this.initialSort && this.initialSort.prop && this.initialSort.direction) {
      this.currentSort.prop = this.initialSort.prop
      this.currentSort.direction = this.initialSort.direction
    }
  }
}
</script>

<style scoped>

</style>